
  import axios from 'axios'
  import { AxiosResponse } from 'axios'
  import Sidebar from '../components/Sidebar.vue'
  import Modal from '../components/Modal.vue'
  import LoadingIcon from '../components/LoadingIcon.vue'
  import { ClassI } from '../interfaces/Class'
  import { AssignDeckData } from '../interfaces/AssignDeckData'
  import { UnassignDeckPayload } from '../interfaces/UnassignDeckPayload'
  import { defineComponent } from 'vue'
  const apiBaseURL = process.env.VUE_APP_API_BASEURL

  export default defineComponent({
    name: 'ClassEdit',
    props: {
      classCode: {
        type: String,
        required: true,
      },
    },
    components: {
      Sidebar,
      Modal,
      LoadingIcon,
    },
    data() {
      return {
        currClass: {
          /* classCode: 'Loading...', */
          /* description: 'Loading...', */
          /* name: 'Loading...', */
          /* teacherName: 'Loading...', */
          /* students: [], */
          /* assignedDecks: [], */
        } as ClassI,
        modalIsVisible: false,
        menuType: 'decks',
        assignDeckProperties: {
          mode: 'learn',
          front: 'pinyin',
          scramble: null,
          repetitions: 1,
          dueDate: new Date(), // placeholder, UNIX timestamp in ms
          classCode: this.classCode,
          deckId: '',
        } as AssignDeckData,
        isLoading: false,
      }
    },
    methods: {
      toggleModalVisibility(): void {
        this.modalIsVisible = !this.modalIsVisible
      },
      callDeleteClass(): void {
        this.$store.dispatch('classes/deleteClass', this.classCode)
        this.toggleModalVisibility()
      },
      async getClassDetails(): Promise<any> {
        return axios({
          method: 'post',
          withCredentials: true,
          url: `${apiBaseURL}/class/class`,
          data: {
            classCode: this.classCode,
          },
        })
          .then((res: AxiosResponse) => {
            this.currClass = res.data
          })
          .catch((err) => {
            console.log(err)
          })
      },
      changeMenuType(menuType: string): void {
        this.menuType = menuType
      },
      callAssignDeck(): void {
        // epoch time in ms
        this.assignDeckProperties.dueDate = new Date(
          this.assignDeckProperties.dueDate
        ).valueOf()
        this.$store.dispatch('classes/assignDeck', this.assignDeckProperties)
        this.menuType = 'decks'
      },
      callUnassignDeck(deckId: string, assignmentId: string): void {
        this.$store.dispatch('classes/unassignDeck', {
          classCode: this.currClass.classCode,
          deckId: deckId,
          assignmentId: assignmentId,
        } as UnassignDeckPayload)
      },
    },
    async created() {
      this.isLoading = true
      await this.getClassDetails()
      this.isLoading = false
    },
  })
